document.addEventListener('DOMContentLoaded', function () {

  /* ---------- Mobile menu ---------- */
  var mobileToggle = document.querySelector('[data-mobile-toggle]');
  var mobileNav = document.querySelector('[data-mobile-nav]');
  if (mobileToggle && mobileNav) {
    mobileToggle.addEventListener('click', function () {
      mobileNav.classList.toggle('is-open');
    });
  }

  /* ---------- Cart drawer ---------- */
  var drawer = document.getElementById('cart-drawer');
  var overlay = document.querySelector('[data-cart-overlay]');

  function openCart() {
    if (!drawer) return;
    drawer.classList.add('is-open');
    overlay.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    refreshCartDrawer();
  }
  function closeCart() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    overlay.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
  }
  document.querySelectorAll('[data-open-cart]').forEach(function (btn) {
    btn.addEventListener('click', function (e) { e.preventDefault(); openCart(); });
  });
  document.querySelectorAll('[data-close-cart]').forEach(function (btn) {
    btn.addEventListener('click', function (e) { e.preventDefault(); closeCart(); });
  });
  if (overlay) overlay.addEventListener('click', closeCart);

  function refreshCartDrawer() {
    fetch('/?section_id=cart-drawer')
      .then(function (res) { return res.text(); })
      .then(function (html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var newContent = doc.querySelector('[data-cart-drawer-content]');
        var current = drawer.querySelector('[data-cart-drawer-content]');
        if (newContent && current) current.innerHTML = newContent.innerHTML;
        updateCartCount();
      })
      .catch(function () {});
  }

  function updateCartCount() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
        });
        updateShippingBar(cart.total_price);
      });
  }

  var FREE_SHIPPING_THRESHOLD = 2000 * 100; // cents, matches settings copy ($2.000)
  function updateShippingBar(totalCents) {
    document.querySelectorAll('[data-shipping-bar]').forEach(function (bar) {
      var fill = bar.querySelector('[data-shipping-fill]');
      var text = bar.querySelector('[data-shipping-text]');
      var pct = Math.min(100, (totalCents / FREE_SHIPPING_THRESHOLD) * 100);
      if (fill) fill.style.width = pct + '%';
      if (text) {
        if (totalCents >= FREE_SHIPPING_THRESHOLD) {
          text.textContent = '¡Felicitaciones! Tenés envío GRATIS 🎉';
        } else {
          var remaining = ((FREE_SHIPPING_THRESHOLD - totalCents) / 100).toFixed(0);
          text.textContent = 'Te faltan $' + remaining + ' para envío GRATIS';
        }
      }
    });
  }

  /* Intercept product forms to add via AJAX and open drawer */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-product-form], form.product-form-ajax');
    if (!form) return;
    e.preventDefault();
    var formData = new FormData(form);
    var submitBtn = form.querySelector('[type="submit"]');
    if (submitBtn) { submitBtn.disabled = true; submitBtn.dataset.original = submitBtn.textContent; submitBtn.textContent = 'Agregando...'; }

    fetch('/cart/add.js', { method: 'POST', body: formData, headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function () {
        openCart();
      })
      .catch(function () {})
      .finally(function () {
        if (submitBtn) { submitBtn.disabled = false; submitBtn.textContent = submitBtn.dataset.original; }
      });
  });

  updateCartCount();

  /* ---------- Sticky add to cart ---------- */
  var stickyAtc = document.querySelector('[data-sticky-atc]');
  var mainAtc = document.querySelector('[data-main-atc]');
  if (stickyAtc && mainAtc) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        stickyAtc.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.top < 0);
      });
    }, { threshold: 0 });
    io.observe(mainAtc);
  }
  var stickyAtcButton = document.querySelector('[data-sticky-atc-button]');
  if (stickyAtcButton && mainAtc) {
    stickyAtcButton.addEventListener('click', function () { mainAtc.click(); });
  }

  /* ---------- Quantity break selector (Buy 1 / 2 / 3) ---------- */
  var qtyBreaks = document.querySelector('[data-quantity-breaks]');
  var qtyInput = document.querySelector('[data-quantity-input]');
  if (qtyBreaks && qtyInput) {
    qtyBreaks.querySelectorAll('[data-qty-break-option]').forEach(function (opt) {
      opt.addEventListener('click', function () {
        qtyBreaks.querySelectorAll('[data-qty-break-option]').forEach(function (o) { o.classList.remove('is-active'); });
        opt.classList.add('is-active');
        qtyInput.value = opt.dataset.qty || 1;
        qtyInput.dispatchEvent(new Event('change'));
      });
    });
  }

  /* ---------- Quantity selectors ---------- */
  document.querySelectorAll('[data-quantity-selector]').forEach(function (sel) {
    var input = sel.querySelector('input');
    sel.querySelectorAll('[data-qty-minus]').forEach(function (b) {
      b.addEventListener('click', function () {
        input.value = Math.max(1, parseInt(input.value || '1', 10) - 1);
        input.dispatchEvent(new Event('change'));
      });
    });
    sel.querySelectorAll('[data-qty-plus]').forEach(function (b) {
      b.addEventListener('click', function () {
        input.value = parseInt(input.value || '1', 10) + 1;
        input.dispatchEvent(new Event('change'));
      });
    });
  });

  /* ---------- Product gallery ---------- */
  document.querySelectorAll('[data-gallery]').forEach(function (gallery) {
    var mainImg = gallery.querySelector('[data-gallery-main]');
    gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        if (mainImg) mainImg.src = thumb.dataset.fullSrc || thumb.src;
        gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
      });
    });
  });

  /* ---------- Countdown timer (urgency) ----------
     Counts down to a REAL end date/time set by the merchant in theme
     settings (settings.sale_end_date, "YYYY-MM-DD HH:MM" Uruguay time,
     fixed UTC-3). It does not reset per visit/session — if it hits zero,
     it stays at zero until the merchant updates the date. This avoids the
     "fake countdown that resets on refresh" dark pattern. */
  document.querySelectorAll('[data-countdown-wrap]').forEach(function (wrap) {
    var el = wrap.querySelector('[data-countdown]');
    if (!el) return;
    var raw = (wrap.dataset.end || '').trim();
    if (!raw) { wrap.style.display = 'none'; return; }
    var iso = raw.replace(' ', 'T') + ':00-03:00';
    var end = new Date(iso).getTime();
    if (isNaN(end)) { wrap.style.display = 'none'; return; }

    function tick() {
      var diff = end - Date.now();
      if (diff <= 0) {
        wrap.style.display = 'none';
        return;
      }
      var d = Math.floor(diff / 86400000);
      var h = Math.floor((diff % 86400000) / 3600000);
      var m = Math.floor((diff % 3600000) / 60000);
      var s = Math.floor((diff % 60000) / 1000);
      var parts = [];
      if (d > 0) parts.push(d + 'd');
      parts.push(String(h).padStart(2, '0') + ':' + String(m).padStart(2, '0') + ':' + String(s).padStart(2, '0'));
      el.textContent = parts.join(' ');
      setTimeout(tick, 1000);
    }
    tick();
  });

});
